<template>
  <StyledDiv>
    <Together />
    <FooterQuestions />
    <StyledDiv class="doubleWrap" flexDirection="row" v-if="!contactForm">
      <StyledDiv width="45%" height="200px">
        <StyledDiv>
          <StyledText :fontSize="styled('fontSize-large')">&#9993;</StyledText>
        </StyledDiv>
        <StyledDiv
          :border="`1px solid ${styled('lightBlue')}`"
          borderRadius="5px"
          hoverBrightness="brightness(90%)"
          :backgroundColor="styled('white')"
          cursor="pointer"
          height="50px"
          width="75%"
          minWidth="250px"
        >
          <a
            href="mailto:literacyloom@gmail.com"
            target="_blank"
            class="anchor"
          >
            <StyledText>send us an email</StyledText>
          </a>
        </StyledDiv>
        <StyledDiv>
          <StyledText padding="25px 0">literacyloom@gmail.com</StyledText>
        </StyledDiv>
      </StyledDiv>
      <StyledDiv
        width="1px"
        height="75px"
        :backgroundColor="styled('black')"
        margin="0 5px"
        class="dividerThing"
      />
      <StyledDiv width="45%" height="200px">
        <StyledDiv>
          <StyledText :fontSize="styled('fontSize-large')">&#9998;</StyledText>
        </StyledDiv>
        <StyledDiv
          :border="`1px solid ${styled('lightBlue')}`"
          borderRadius="5px"
          :backgroundColor="styled('white')"
          hoverBrightness="brightness(90%)"
          cursor="pointer"
          @click="toggleContactForm"
          height="50px"
          width="75%"
          minWidth="250px"
        >
          <StyledText>leave us a note</StyledText>
        </StyledDiv>
        <StyledDiv>
          <StyledText padding="25px 0">we're listening...</StyledText>
        </StyledDiv>
      </StyledDiv>
    </StyledDiv>
    <ContactForm v-if="contactForm" :cancelFunc="toggleCancel" />
    <VeryBottom />
  </StyledDiv>
</template>

<script>
import { StyledDiv, StyledText } from "../styled";
import StyleCompiler from "../styled/StyleCompiler";
import headerImage from "../assets/images/ProjectBoard.jpeg";
import Together from "./Together";
import FooterQuestions from "./FooterQuestions";
import VeryBottom from "./VeryBottom";
import ContactForm from "./ContactForm";
export default {
  components: {
    StyledDiv,
    Together,
    VeryBottom,
    FooterQuestions,
    ContactForm,
    StyledText
  },
  data() {
    return {
      headShot: headerImage,
      contactForm: false,
      thanksBarDisplayed: false,
      errorBarDisplayed: false
    };
  },
  methods: {
    toggleCancel() {
      this.contactForm = false;
    },

    toggleContactForm() {
      this.contactForm = !this.contactForm;
    },
    styled(e) {
      return StyleCompiler(e);
    }
  }
};
</script>

<style>
.anchor {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}
@media (max-width: 768px) {
  .doubleWrap {
    flex-direction: column;
  }
  .dividerThing {
    width: 75%;
    height: 1px;
  }
}
</style>
